import React from 'react'

export interface IConnectionContext {
  setUserStream: (stream: MediaStream | undefined) => void
  setUserVideoElement: (videoElt: HTMLVideoElement) => void
  setAvatarStream: (stream: MediaStream) => void
  setAvatarVideoElement: (videoElt: HTMLVideoElement) => void
}

const Ctx = React.createContext<IConnectionContext>({
  setUserStream: () => undefined,
  setUserVideoElement: () => undefined,
  setAvatarStream: () => undefined,
  setAvatarVideoElement: () => undefined
})

export default Ctx
